export default "__VITE_ASSET__0cc9584f__"